import MechanicResume from "./MechanicResume";
import Top7Mechanics from "./top7Mechanics";

function ManpowerDashboard() {
  return (
    <>
      <div>
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#/">MANPOWER</a>
          </li>
          <li className="breadcrumb-item active">Dashboard</li>
        </ul>

        <h1 className="page-header">
          Plant Manpower Dashboard <small></small>
        </h1>
        <hr className="mb-4" />
        <MechanicResume />
        <Top7Mechanics />
      </div>
    </>
  );
}
export default ManpowerDashboard;
